import React from "react";
import { Outlet, Link } from "react-router-dom";
import Navbar from "./Navbar";
import {ThemeSelector} from "./Theme";
import Footer from "./Footer";
const Layout = () => {
    return (
        <ThemeSelector>
            <Navbar />
            <main>
                <Outlet />
            </main>
            <Footer />
        </ThemeSelector>
    );
};
export default Layout;